import {
  Box,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from "@chakra-ui/react";
import FacebookFeedPreview from "../../components/AdPreview/FacebookFeedPreview";
import FacebookStoryPreview from "../../components/AdPreview/FacebookStoryPreview";
import InstagramPostPreview from "../../components/AdPreview/InstagramPostPreview";
import InstagramStoryPreview from "../../components/AdPreview/InstagramStoryPreview";
import type { CreativeBlock } from "../types";

type CreateCampaignFlowPreviewProps = {
  mobilePanel: "editor" | "preview";
  creatives: CreativeBlock[];
  fieldIds: string[];
  ctaText: string;
  websiteUrl: string;
  eventName: string;
  eventDescription: string;
};

export default function CreateCampaignFlowPreview({
  mobilePanel,
  creatives,
  fieldIds,
  ctaText,
  websiteUrl,
  eventName,
  eventDescription,
}: CreateCampaignFlowPreviewProps) {
  return (
    <Box
      flex={1}
      rounded="xl"
      alignSelf="stretch"
      display={{
        base: mobilePanel === "preview" ? "block" : "none",
        md: "block",
      }}
    >
      <Tabs variant="soft-rounded" colorScheme="gray" size="sm">
        <TabList bg="gray.200" rounded="lg" p={1} maxW="80%" mx="auto">
          <Tab
            _selected={{ bg: "white", shadow: "sm" }}
            rounded="md"
            width="50%"
          >
            <Text fontSize="xs">Instagram Preview</Text>
          </Tab>
          <Tab
            _selected={{ bg: "white", shadow: "sm" }}
            rounded="md"
            width="50%"
          >
            <Text fontSize="xs">Facebook Preview</Text>
          </Tab>
        </TabList>
        <TabPanels pt={4}>
          <TabPanel px={0}>
            <VStack align="stretch" spacing={6} w="full">
              {fieldIds.map((fieldId, index) => {
                const creative = creatives[index];
                if (!creative) return null;

                return (
                  <Stack key={`instagram-preview-${fieldId}`} spacing={6}>
                    <InstagramPostPreview
                      username={
                        creative.instagramAccount?.username ?? "Account"
                      }
                      message={creative.primaryText}
                      ctaText={ctaText}
                      mediaUrls={
                        creative.squareMediaUrl ? [creative.squareMediaUrl] : []
                      }
                      profilePictureUrl={
                        creative.instagramAccount?.profile_picture_url ||
                        undefined
                      }
                      mediaType="single"
                      fullWidth={true}
                    />
                    <InstagramStoryPreview
                      username={
                        creative.instagramAccount?.username ?? "Account"
                      }
                      ctaText={ctaText}
                      mediaUrls={
                        creative.verticalMediaUrl
                          ? [creative.verticalMediaUrl]
                          : []
                      }
                      profilePictureUrl={
                        creative.instagramAccount?.profile_picture_url ||
                        undefined
                      }
                      mediaType="single"
                      fullWidth={true}
                    />
                  </Stack>
                );
              })}
            </VStack>
          </TabPanel>
          <TabPanel px={0}>
            <VStack align="stretch" spacing={6} w="full">
              {fieldIds.map((fieldId, index) => {
                const creative = creatives[index];
                if (!creative) return null;

                return (
                  <Stack key={`facebook-preview-${fieldId}`} spacing={6}>
                    <FacebookFeedPreview
                      message={creative.primaryText}
                      ctaText={ctaText}
                      mediaUrls={
                        creative.squareMediaUrl ? [creative.squareMediaUrl] : []
                      }
                      mediaType="single"
                      pageName={creative.fbPage?.name ?? "Account"}
                      profilePictureUrl={creative.fbPage?.picture || undefined}
                      websiteUrl={websiteUrl}
                      eventName={eventName}
                      description={eventDescription}
                      fullWidth={true}
                    />
                    <FacebookStoryPreview
                      message={creative.primaryText}
                      ctaText={ctaText}
                      mediaUrls={
                        creative.verticalMediaUrl
                          ? [creative.verticalMediaUrl]
                          : []
                      }
                      mediaType="single"
                      pageName={creative.fbPage?.name ?? "Account"}
                      profilePictureUrl={creative.fbPage?.picture || undefined}
                      websiteUrl={websiteUrl}
                      eventName={eventName}
                      description={eventDescription}
                      fullWidth={true}
                    />
                  </Stack>
                );
              })}
            </VStack>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
